import type { RowClassRules } from 'ag-grid-community';
import type { LibrarySearchEntity } from 'venn-api';

export const rowClassRules: RowClassRules<LibrarySearchEntity> = {
  '!bg-venn-light-warning': (params) => {
    return params.data?.lastSyncStatus === 'PARTIAL';
  },

  '!bg-venn-light-error': (params) => {
    return params.data?.lastSyncStatus === 'FAILED';
  },
};
